import messages_en from './translations/en.json';
import messages_ru from './translations/ru.json';
import { LocalStorage } from '@utils/utils';

export const STATIC_PATH = '/office';

export const API_VERSION = 'v1';

export const getBaseApiUrl = () => {
  // Check more specific envs before `.local` (hosts like office-local.devstage… or *.local.devstage…)
  if (
    window.location.origin.includes('.devstage.ttplace.online') ||
    window.location.host.includes('.devstage.ttplace.online')
  ) {
    return 'https://api.devstage.ttplace.online';
  }

  if (window.location.origin.includes('.local') || window.location.host.includes('.local')) {
    return 'http://api.incus.local';
  }

  return 'https://api.affiliate.tutorplace.ru';
};

export const getFrontUrl = () => {
  if (
    window.location.origin.includes('.devstage.ttplace.online') ||
    window.location.host.includes('.devstage.ttplace.online')
  ) {
    return 'https://front.devstage.ttplace.online';
  }

  if (window.location.origin.includes('.local') || window.location.host.includes('.local')) {
    return 'http://front.incus.local';
  }

  return 'https://affiliate.tutorplace.ru';
};

export const getAuthUrl = () => {
  const frontUrl = getFrontUrl();

  return `${frontUrl}/publisher/sign_in`;
};

export const appStructure = {
  dashboard: {
    id: 'dashboard',
    title: 'Dashboard',
    path: '/dashboard',
    translated: 'navigation.dashboard',
    subnav: [],
  },
  statistics: {
    id: 'statistics',
    title: 'Statistics',
    translated: 'navigation.statistics',
    path: () => {
      const currentPath = window.location.pathname;
      if (currentPath.includes('/statistics')) {
        return '/statistics?template=7';
      }
      return '/statistics?template=7';
    },
    subnav: [],
  },
  offers: {
    id: 'offers',
    title: 'Offers',
    translated: 'navigation.offers',
    path: '/offers/all',
    subnav: [],
  },
  tools: {
    id: 'tools',
    title: 'Tools',
    translated: 'navigation.tools',
    path: '/tools',
    subnav: {
      flows: {
        id: 'flows',
        title: 'Flows',
        path: '/tools/flows',
        translated: 'navigation.tools.flows',
      },
      // domains: {
      //   id: 'domains',
      //   title: 'Domains parking',
      //   path: '/tools/domains',
      //   translated: 'navigation.tools.domains',
      // },
      // agencies: {
      //   id: 'agencies',
      //   title: 'Bonuses',
      //   path: '/tools/bonuses',
      //   translated: 'navigation.tools.bonuses',
      // },
      'global-postback': {
        id: 'global-postback',
        title: 'Global postback',
        path: '/tools/global-postback',
        translated: 'navigation.tools.global-postback',
      },
      // api: {
      //   id: 'api',
      //   title: 'Передача заявок по API',
      //   path: '/tools/api',
      //   translated: 'pages.transfer-request-by-api.title',
      //   hasUpperText: true,
      //   upperTextClassName: 'nav-highlight-circle',
      // },
      'master-account': {
        id: 'master-account',
        title: 'Master account',
        path: '/tools/master?type=times',
        translated: 'navigation.master',
      },
      // 'mobile-app': {
      //   id: 'mobile-app',
      //   title: 'Лей через приложение',
      //   path: '/tools/mobile-app',
      //   translated: 'navigation.mobile-app',
      //   upperTextClassName: 'nav-master-new',
      // },
      // 'tiktok': {
      //   id: 'tiktok',
      //   title: 'Кабинеты TikTok',
      //   path: '/tools/tiktok',
      //   translated: 'navigation.tiktok',
      //   upperTextClassName: 'nav-master-new',
      // },
      // 'tiktok-ru': {
      //   id: 'tiktok-ru',
      //   title: 'Кабинеты TikTok RUB',
      //   path: '/tools/tiktokRUB',
      //   translated: 'navigation.tiktok-ru',
      //   upperTextClassName: 'nav-master-new',
      // },
      // 'iniq': {
      //   id: 'uniq',
      //   title: 'Уникализатор',
      //   path: 'https://uniq.offerrum.com/',
      //   translated: 'navigation.uniq',
      //   upperTextClassName: 'nav-master-new',
      // },
      // referral: {
      //   id: 'referral',
      //   title: 'Referral System',
      //   path: '/tools/referral',
      //   translated: 'navigation.tools.referral',
      // },
      // sitekey: {
      //   title: 'Site Key',
      //   path: '/tools/sitekey',
      //   translated: 'navigation.tools.api',
      // },
    },
  },
  news: {
    id: 'news',
    title: 'News',
    path: '/news',
    subnav: [],
    translated: 'navigation.news',
  },
  account: {
    id: 'account',
    title: 'Account',
    path: '/account',
    translated: 'account.title',
    subnav: {
      profile: {
        id: 'profile',
        title: 'Profile',
        path: '/account/profile',
        translated: 'account.profile',
      },
      security: {
        id: 'security',
        title: 'Security',
        path: '/account/security',
        translated: 'account.security',
      },
      payment: {
        id: 'payment',
        title: 'Requisites',
        path: '/account/payment-data',
        translated: 'account.payment-requisites',
      },
      finances: {
        id: 'finances',
        title: 'Payments',
        path: '/profile/payments',
        translated: 'account.payments',
      },
      // notifications: {
      //   id: 'notifications',
      //   title: 'Notifications',
      //   path: '/profile/notifications',
      //   translated: 'account.notifications',
      // },
      logout: {
        id: 'logout',
        title: 'Sign Out',
        path: '/logout',
        translated: 'account.sign-out',
      },
    },
  },

  help: {
    id: 'help',
    title: 'Help 24/7',
    path: '/help',
    translated: 'navigation.help',
    upperTextClassName: 'nav-help-link',
    subnav: {
      faq: {
        id: 'faq',
        title: 'FAQ',
        path: '/faq',
        translated: 'navigation.help.faq',
      },
      support: {
        id: 'support',
        title: 'Support 24/7',
        path: '/tickets',
        translated: 'navigation.help.support',
        upperTextClassName: 'nav-highlight-circle',
      },
    },
  },
  profile: {
    id: 'account',
    title: 'Account',
    path: '/profile',
    translated: 'account.title',
    subnav: {
      profile: {
        id: 'profile',
        title: 'Profile',
        path: '/profile/edit',
        translated: 'account.profile',
      },
      security: {
        id: 'security',
        title: 'Security',
        path: '/profile/security',
        translated: 'account.security',
      },
      payment: {
        id: 'payment',
        title: 'Requisites',
        path: '/profile/payment-data',
        translated: 'account.payment-requisites',
      },
      // contracts: {
      //   id: 'contracts',
      //   title: 'Contracts',
      //   path: '/profile/contracts',
      //   translated: 'navigation.tools.contracts',
      //   upperTextClassName: 'nav-highlight-circle',
      // },
      finances: {
        id: 'finances',
        title: 'Payments',
        path: '/profile/payments',
        translated: 'account.payments',
      },
      // promo: {
      //   id: 'promo',
      //   title: 'Промокоды',
      //   path: '/promo',
      //   translated: 'account.promo',
      // },
      // notifications: {
      //   id: 'notifications',
      //   title: 'Notifications',
      //   path: '/profile/notifications',
      //   translated: 'account.notifications',
      // },
      // contracts: {
      //   id: 'contracts',
      //   title: 'Contract work',
      //   path: '/profile/contracts',
      //   translated: 'account.contracts',
      //   hasUpperText: true,
      //   upperTextClassName: 'nav-contacts-uppertext',
      //   upperPath: 'globalSettings.contract_bonus'
      // },
      // socials: {
      //   id: 'socials',
      //   title: 'Social Networks',
      //   path: '/profile/socials',
      //   translated: 'socials.title',
      // },
      logout: {
        id: 'logout',
        title: 'Sign Out',
        path: '/logout',
        translated: 'account.sign-out',
      },
    },
  },
};

export const sideBarNav = {
  dashboard: {
    id: 'dashboard',
    title: 'Main',
    path: '/dashboard',
    translated: 'navigation.dashboard',
    subnav: [],
  },
  news: appStructure.news,
  offers: {
    id: 'offers',
    title: 'Offers',
    translated: 'navigation.offers',
    path: '/offers',
    subnav: {
      allOffers: {
        id: 'all',
        title: 'All Offers',
        path: '/offers/all',
        translated: 'navigation.offers.all',
      },
      myOffers: {
        id: 'my',
        title: 'My Offers',
        path: '/offers/my',
        translated: 'navigation.offers.my',
      },
      // newOffers: {
      //   id: 'new',
      //   title: 'New Offers',
      //   path: '/offers/new',
      //   translated: 'navigation.offers.new',
      // },
      exclusiveOffers: {
        id: 'exclusive',
        title: 'Exclusive Offers',
        path: '/offers/exclusive',
        translated: 'navigation.offers.exclusive',
      },
    },
  },
  flows: {
    id: 'flows',
    title: 'Flows',
    path: '/flows',
    translated: 'navigation.tools.flows',
    subnav: {
      myFlows: {
        id: 'my flows',
        title: 'My Flows',
        path: '/tools/flows',
        translated: 'navigation.tools.flows.my',
      },
      createFlow: {
        id: 'add flow',
        title: 'Add Flow',
        path: '/tools/flows/create',
        translated: 'flows.buttons.add-flow',
      },
    },
  },
  statistics: {
    ...appStructure.statistics,
    subnav: {
      times: {
        id: 'times',
        title: 'Date',
        path: '/statistics?type=times',
        translated: 'navigation.statistics.times.theme_3',
        clickHandler: 'statisticsChangeTab',
      },
      conversions: {
        id: 'conversions',
        title: 'Conversions',
        path: '/statistics?type=leads',
        translated: 'navigation.statistics.times.conversions.theme_3',
        clickHandler: 'statisticsChangeTab',
      },
    },
  },
  tools: {
    ...appStructure.tools,
    subnav: {
      'transfer-by-api': {
        id: 'transfer-by-api',
        title: 'Передача заявок по API',
        path: '/tools/transfer-by-api',
        translated: 'navigation.sidebar.transfer-request-by-api.title.theme_3',
        hasUpperText: true,
        upperTextClassName: 'nav-highlight-circle',
      },
      domains: {
        id: 'domains',
        title: 'Domains parking',
        path: '/tools/domains',
        translated: 'navigation.sidebar.tools.domains',
      },
      // agencies: {
      //   id: 'agencies',
      //   title: 'Bonuses',
      //   path: '/tools/bonuses',
      //   translated: 'navigation.tools.bonuses',
      // },
      // services: {
      //   id: 'services',
      //   title: 'Services',
      //   path: '/tools/bonuses/services',
      //   translated: 'navigation.tools.bonuses.agents',
      // },
      // agencies: {
      //   id: 'bonuses',
      //   title: 'Bonuses',
      //   path: '/tools/bonuses',
      //   translated: 'navigation.tools.bonuses.services',
      // },

      sources: {
        id: 'sources',
        title: 'Sources',
        path: '/tools/sources',
        translated: 'navigation.tools.sources',
      },
      'global-postback': {
        id: 'global-postback',
        title: 'Global postback',
        path: '/tools/global-postback/logs',
        translated: 'navigation.tools.global-postback',
      },
      // 'mobile-app': {
      //   id: 'mobile-app',
      //   title: 'Лей через приложение',
      //   path: '/tools/mobile-app',
      //   translated: 'navigation.mobile-app',
      //   upperTextClassName: 'nav-master-new',
      // },
    },
  },
  payments: {
    id: 'payments',
    title: 'Payments',
    path: 'profile/payment',
    translated: 'navigation.finances',
    subnav: {
      // payment: {
      //   id: 'payment',
      //   title: 'Payment Data',
      //   path: '/profile/payment-data',
      //   translated: 'navigation.sidebar.payments.data.title',
      // },
      financesInfo: {
        id: 'financesInfo',
        title: 'Financial info',
        path: '/profile/payments',
        translated: 'navigation.sidebar.payments.list.title',
      },
      financesOrder: {
        id: 'financesOrder',
        title: 'Payments order',
        path: '/profile/payments/order',
        translated: 'navigation.sidebar.payments.order.title',
      },
      financesHold: {
        id: 'financesHold',
        title: 'Hold detail',
        path: '/profile/payments/hold',
        translated: 'payments.hold.title',
      },
    },
  },
  master: {
    id: 'masterAccount',
    title: 'Master account',
    path: '/tools/master',
    translated: 'navigation.master.theme_3',
    subnav: [],
  },
  tickets: {
    ...appStructure.help.subnav.support,
    translated: 'tickets.header.title',
    subnav: [],
    upperTextClassName: null,
  },
  faq: { ...appStructure.help.subnav.faq, subnav: [] },
};

export const navigation = [
  appStructure.dashboard,
  appStructure.statistics,
  // { ...appStructure.profile.subnav.finances, subnav: [] },
  appStructure.offers,
  appStructure.tools,
  appStructure.news,
  appStructure.help,
  appStructure.profile,
];

// const storePath = getStoreUrl()

export const primaryNav = [
  {
    id: 'dashboard',
    title: 'Dashboard',
    path: '/statistics',
    subnav: [],
    translated: 'navigation.dashboard',
  },
  appStructure.help.subnav.faq,
  {
    id: 'contacts',
    title: 'Contacts',
    path: '/contacts',
    subnav: [],
    translated: 'navigation.contacts',
  },
  {
    id: 'store',
    title: 'Store',
    path: '/',
    isExternal: true,
    subnav: [],
    translated: 'navigation.store',
  },
];

export const secondaryHeader = [
  { ...appStructure.statistics, hideOnLg: true },
  { ...appStructure.news, hideOnLg: true },
  // {
  //   id: 'important',
  //   title: 'Important',
  //   path: '/important',
  //   subnav: [],
  //   translated: 'navigation.secondary.important',
  //   hideOnLg: true,
  // },
  {
    ...appStructure.help.subnav.support,
    subnav: [],
    translated: 'navigation.help.support.theme_4',
    hideOnLg: true,
  },
  {
    ...appStructure.profile.subnav.finances,
    hideOnLg: true,
    subnav: [],
    translated: 'account.payments.theme_4',
  },
  {
    ...appStructure.offers,
    hideOnLg: true,
    subnav: {
      allOffers: {
        id: 'allOffers',
        title: 'All Offers',
        path: '/offers',
        translated: 'navigation.offers.all',
      },
      myOffers: {
        id: 'myOffers',
        title: 'My Offers',
        path: '/offers/my',
        translated: 'navigation.offers.my',
      },
      myLinks: {
        id: 'myLinks',
        title: 'My Links',
        path: '/tools/flows',
        translated: 'navigation.offers.links',
      },
    },
  },
  {
    id: 'tools',
    title: 'Tools',
    hideOnLg: true,
    translated: 'navigation.tools',
    path: '/tools',
    subnav: {
      // domains: {
      //   id: 'domains',
      //   title: 'Domains parking',
      //   path: '/tools/domains',
      //   search: '?tab=create',
      //   translated: 'navigation.tools.domains',
      // },
      'global-postback': {
        id: 'global-postback',
        title: 'Global postback',
        path: '/tools/global-postback',
        translated: 'navigation.tools.global-postback',
      },
      logs: {
        id: 'logs',
        title: 'Postback logs',
        path: '/tools/global-postback/logs',
        translated: 'postback.logs.title',
      },
      sources: {
        id: 'sources',
        title: 'Sources',
        path: '/tools/sources',
        translated: 'navigation.tools.sources',
      },
      agencies: {
        id: 'agencies',
        title: 'Bonuses',
        path: '/tools/bonuses',
        translated: 'navigation.tools.bonuses',
      },
      // api: {
      //   id: 'api',
      //   title: 'Передача заявок по API',
      //   path: '/tools/api',
      //   translated: 'pages.transfer-request-by-api.title',
      //   hasUpperText: true,
      //   upperTextClassName: 'nav-highlight-circle',
      // },
      'master-account': {
        id: 'masterAccount',
        title: 'Master account',
        path: '/tools/master',
        translated: 'navigation.master',
        upperTextClassName: 'nav-master-new',
      },
      // 'mobile-app': {
      //   id: 'mobile-app',
      //   title: 'Лей через приложение',
      //   path: '/tools/mobile-app',
      //   translated: 'navigation.mobile-app',
      // },
    },
  },
  {
    id: 'docs',
    title: 'Documentation',
    path: '/docs',
    subnav: [],
    hideOnLg: true,
    translated: 'navigation.secondary.documentation',
  },
];

export const profileNav4 = [
  {
    id: 'my profile',
    title: 'My Profile',
    path: '/profile/info',
    translated: 'account.info',
  },
  {
    id: 'profile',
    title: 'Profile',
    path: '/profile/edit',
    translated: 'account.profile',
  },
  {
    id: 'security',
    title: 'Security',
    path: '/profile/security',
    translated: 'account.security',
  },
  {
    id: 'telegram',
    title: 'Telegram',
    path: '/profile/telegram',
    translated: 'account.telegram',
  },
  // {
  //   id: 'notifications',
  //   title: 'Notifications',
  //   path: '/profile/notifications',
  //   translated: 'account.notifications',
  // },
  {
    id: 'payment',
    title: 'Requisites',
    path: '/profile/payment-data',
    translated: 'account.payment-requisites',
  },
  // {
  //   id: 'contracts',
  //   title: 'Contracts',
  //   path: '/profile/contracts',
  //   translated: 'navigation.tools.contracts',
  // },
  {
    id: 'avatar',
    title: 'Change avatar',
    path: '/profile/avatar',
    translated: 'account.avatar',
  },
];

export const dashboardSettings = [
  {
    id: 1,
    position: 0,
    enabled: true,
  },

  {
    id: 2,
    position: 1,
    enabled: true,
  },

  {
    id: 3,
    position: 3,
    enabled: true,
  },

  {
    id: 12,
    position: 1,
    enabled: true,
  },

  {
    id: 21,
    position: 2,
    enabled: true,
  },

  {
    id: 14,
    position: 3,
    enabled: true,
  },

  {
    id: 11,
    position: 4,
    enabled: true,
  },

  {
    id: 15,
    position: 5,
    enabled: true,
  },

  {
    id: 10,
    position: 6,
    enabled: true,
  },
  // {
  //   id: 13,
  //   position: 0,
  //   enabled: true,
  // },
  {
    id: 20,
    position: 7,
    enabled: true,
  },
];

export const dashboardSettings3 = [
  {
    id: 1,
    position: 0,
    enabled: true,
  },

  {
    id: 2,
    position: 2,
    enabled: true,
  },

  {
    id: 3,
    position: 1,
    enabled: true,
  },

  {
    id: 10,
    position: 1,
    enabled: false,
  },

  {
    id: 11,
    position: 2,
    enabled: false,
  },

  {
    id: 12,
    position: 3,
    enabled: true,
  },

  // {
  //   id: 13,
  //   position: 0,
  //   enabled: true,
  // },

  {
    id: 14,
    position: 0,
    enabled: false,
  },

  {
    id: 20,
    position: 0,
    enabled: false,
  },
];

export const messages = {
  en: messages_en,
  ru: messages_ru,
};

export const defaultLocale = 'en';

export const defaultLanguages = [
  { key: 'en', title: 'English' },
  { key: 'ru', title: 'Русский' },
];

export const defaultThemes = [{ id: 1, name: 'OFFERRUM' }];

export const defaultTheme = 1;

const usedLocalStorageIds = [
  'SideBarHeader',
  'IntroWidget',
  'NewsWidget',
  'StatisticsChartWidget',
  'RecommendedOffersWidget',
  'SummaryWidget',
  'PersonalManagerWidget',
  'NewOffersWidget',
  'StoreWidget',
  // 'SPNutraWidget',
  // 'SPStoreWidget'
];
